import { useEffect, useRef } from 'react';
import { useDashboard } from '@/context/DashboardContext';
import { useSiteLang, FlagES, FlagEN } from '@/components/site/SiteLang';
import { dashboardApi } from '@/services/dashboardApi';

/*
  Idioma del panel del socio (05/11/2026): español o inglés británico.
  - Al entrar, manda el idioma guardado en la cuenta (user.lang). Las cuentas antiguas no lo tienen: se
    quedan con el del navegador.
  - Las banderas cambian el idioma al momento y lo guardan en la cuenta (los emails le llegan en ese idioma).
  El panel de administración sigue en español.
*/
export function useDashLangSync() {
  const { user } = useDashboard();
  const { lang, setLang } = useSiteLang();
  const done = useRef(null);
  useEffect(() => {
    if (!user?.id || done.current === user.id) return;
    done.current = user.id;
    if ((user.lang === 'en' || user.lang === 'es') && user.lang !== lang) setLang(user.lang);
  }, [user?.id, user?.lang]);
}

export default function DashLangSwitch() {
  const { user } = useDashboard();
  const { lang, setLang } = useSiteLang();
  const pick = (code) => {
    if (code === lang) return;
    setLang(code);
    try {
      const stored = JSON.parse(sessionStorage.getItem('dashboard_user') || 'null');
      if (stored) sessionStorage.setItem('dashboard_user', JSON.stringify({ ...stored, lang: code }));
    } catch { /* sin almacenamiento */ }
    if (user) dashboardApi.setMyLang(code).catch(() => {});
  };
  return (
    <div className="flex items-center" data-testid="dash-lang-switcher">
      {[['es', 'Español', FlagES], ['en', 'English', FlagEN]].map(([code, label, Flag]) => (
        <button key={code} type="button" onClick={() => pick(code)} aria-label={label} aria-pressed={lang === code} title={label}
          className={`w-8 h-8 flex items-center justify-center transition-opacity ${lang === code ? '' : 'opacity-40 hover:opacity-80'}`}
          data-testid={`dash-lang-${code}`}>
          <span className={`w-5 h-5 rounded-full overflow-hidden border-2 flex items-center justify-center ${lang === code ? 'border-[#c9a84c]' : 'border-transparent'}`}>
            <Flag className="w-full h-full" />
          </span>
        </button>
      ))}
    </div>
  );
}
